import {POST} from '@tutils/api';
import CONST from "@/utils/Constants";
import { EventBus } from '@global/event-bus';

const URL = '/ws/cart/add';

export default async (dataR) => {
  try {
    EventBus.$emit(CONST.EVENT.LOADER.SHOW);
    const {data} = await POST(URL, dataR);
    EventBus.$emit(CONST.EVENT.LOADER.HIDE);
    return data;
  } catch (e) {
    EventBus.$emit(CONST.EVENT.LOADER.HIDE);
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/utils/api/post/cart/addToCart.js